import React, { useState, useEffect } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   Box,
   Text,
   FormControl,
   FormLabel,
   Select,
   Checkbox,
   Button,
   Flex,
   VStack,
   HStack,
   ModalFooter,
   Collapse,
   Switch,
   SimpleGrid,
   Icon,
   useColorModeValue,
} from '@chakra-ui/react';
import {
   ChevronRightIcon,
   ChevronDownIcon,
   CheckCircleIcon
} from '@chakra-ui/icons';
import {
   Wrench,
   Trash2,
   GitMerge,
   FileText,
   Building2,
   Database,
   Barcode,
   RefreshCw,
   Monitor,
   Printer,
   ShieldBan,
   BoxIcon,
   MessageSquare,
   Phone,
} from 'lucide-react';
import { useDispatch } from 'react-redux';
import { updateUserRights } from '../../../redux/actions/user';
import { getUser } from '../../../redux/actions/user';

const initialUserRights = {
   dashboard: { add: false, edit: false, deleteRole: false, print: false, view: false },
   journalvouchers: { add: false, edit: false, deleteRole: false, print: false, view: false },
   reports: { add: false, edit: false, deleteRole: false, print: false, view: false },
   profile: { add: false, edit: false, deleteRole: false, print: false, view: false },
   companyprofile: { add: false, edit: false, deleteRole: false, print: false, view: false },
   cashReceive: { add: false, edit: false, deleteRole: false, print: false, view: false },
   cashPayment: { add: false, edit: false, deleteRole: false, print: false, view: false },
   bankReceive: { add: false, edit: false, deleteRole: false, print: false, view: false },
   bankPayment: { add: false, edit: false, deleteRole: false, print: false, view: false },

   // Masters
   customer: { add: false, edit: false, deleteRole: false, print: false, view: false },
   vendor: { add: false, edit: false, deleteRole: false, print: false, view: false },
   allAccount: { add: false, edit: false, deleteRole: false, print: false, view: false },
   item: { add: false, edit: false, deleteRole: false, print: false, view: false },
   category: { add: false, edit: false, deleteRole: false, print: false, view: false },
   brand: { add: false, edit: false, deleteRole: false, print: false, view: false },
   salerepresentative: { add: false, edit: false, deleteRole: false, print: false, view: false },
   itemGroup: { add: false, edit: false, deleteRole: false, print: false, view: false },
   warehouse: { add: false, edit: false, deleteRole: false, print: false, view: false },
   unit: { add: false, edit: false, deleteRole: false, print: false, view: false },
   screen: { add: false, edit: false, deleteRole: false, print: false, view: false },
   daybook: { add: false, edit: false, deleteRole: false, print: false, view: false },
   billtterm: { add: false, edit: false, deleteRole: false, print: false, view: false },
   bankbranch: { add: false, edit: false, deleteRole: false, print: false, view: false },
   transport: { add: false, edit: false, deleteRole: false, print: false, view: false },
   driver: { add: false, edit: false, deleteRole: false, print: false, view: false },
   vehicle: { add: false, edit: false, deleteRole: false, print: false, view: false },
   color: { add: false, edit: false, deleteRole: false, print: false, view: false },
   style: { add: false, edit: false, deleteRole: false, print: false, view: false },
   size: { add: false, edit: false, deleteRole: false, print: false, view: false },
   hsn: { add: false, edit: false, deleteRole: false, print: false, view: false },
   countries: { add: false, edit: false, deleteRole: false, print: false, view: false },
   states: { add: false, edit: false, deleteRole: false, print: false, view: false },
   city: { add: false, edit: false, deleteRole: false, print: false, view: false },
   area: { add: false, edit: false, deleteRole: false, print: false, view: false },

   // Sale
   saleinvoice: { add: false, edit: false, deleteRole: false, print: false, view: false },
   salereturn: { add: false, edit: false, deleteRole: false, print: false, view: false },
   saleorder: { add: false, edit: false, deleteRole: false, print: false, view: false },
   salechallan: { add: false, edit: false, deleteRole: false, print: false, view: false },

   // Purchase
   purchaseinvoice: { add: false, edit: false, deleteRole: false, print: false, view: false },
   purchasereturn: { add: false, edit: false, deleteRole: false, print: false, view: false },
   purchaseorder: { add: false, edit: false, deleteRole: false, print: false, view: false },
   purchasechallan: { add: false, edit: false, deleteRole: false, print: false, view: false },

   // Inventory
   inventory: { add: false, edit: false, deleteRole: false, print: false, view: false },
   inventoryissue: { add: false, edit: false, deleteRole: false, print: false, view: false },
   inventoryreceive: { add: false, edit: false, deleteRole: false, print: false, view: false },
   inventorystocktransfer: { add: false, edit: false, deleteRole: false, print: false, view: false },
   utility: {
      "Delete Unused Master": false, "Synced Un-Approved Entry": false, "Merge Code": false, "E-Way Bill": false, "Bank Import": false,
      "Bulk Update Suspense Account": false, "Generate Dynamic Barcode": false, "Check OS": false, "Print Barcode": false, "Entry Block Manager": false, "Stock Approvel": false
   },
   chat: {
      view: false,
      showPhone: false
   },
};

const ManageUserRoleForm = ({
   isOpen,
   onClose,
   selectedMember,
   companyList,
   processedData,
   onSaveUserRights,
   selectedSharedCompId,
}) => {
   const [selectedCompany, setSelectedCompany] = useState('');
   const [userRights, setUserRights] = useState(initialUserRights);
   const [userRightsByCompany, setUserRightsByCompany] = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const [expandedSections, setExpandedSections] = useState({
      masters: false,
      sale: false,
      purchase: false,
      inventory: false,
      cash: false,
      bank: false,
   });
   const dispatch = useDispatch();
   const isSharedMode = !!onSaveUserRights;
   const userId = localStorage.getItem('userId');

   useEffect(() => {
      if (isOpen) {
         if (isSharedMode && processedData) {
            let companyId = '';

            if (selectedSharedCompId) {
               companyId = selectedSharedCompId.toString();
            } else if (processedData.companyId) {
               companyId = processedData.companyId.toString();
            } else if (processedData.userRights?.[0]?.companyId) {
               companyId = processedData.userRights[0].companyId.toString();
            }

            setSelectedCompany(companyId);

            if (processedData.userRights?.[0]) {
               const { companyId: _, ...permissions } = processedData.userRights[0];
               const mergedRights = { ...initialUserRights };

               Object.keys(permissions).forEach((key) => {
                  if (mergedRights.hasOwnProperty(key)) {
                     if (key === 'utility') {
                        mergedRights[key] = {
                           "Delete Unused Master": permissions[key]?.["Delete Unused Master"] || false,
                           "Synced Un-Approved Entry": permissions[key]?.["Synced Un-Approved Entry"] || false,
                           "Merge Code": permissions[key]?.["Merge Code"] || false,
                           "E-Way Bill": permissions[key]?.["E-Way Bill"] || false,
                           "Bank Import": permissions[key]?.["Bank Import"] || false,
                           "Bulk Update Suspense Account": permissions[key]?.["Bulk Update Suspense Account"] || false,
                           "Generate Dynamic Barcode": permissions[key]?.["Generate Dynamic Barcode"] || false,
                           "Check OS": permissions[key]?.["Check OS"] || false,
                           "Print Barcode": permissions[key]?.["Print Barcode"] || false,
                           "Entry Block Manager": permissions[key]?.["Entry Block Manager"] || false,
                           "Stock Approvel": permissions[key]?.["Stock Approvel"] || false,
                        };
                     } else if (key === 'chat') {
                        mergedRights[key] = {
                           view: permissions[key]?.view || false,
                           showPhone: permissions[key]?.showPhone || false,
                        };
                     } else {
                        mergedRights[key] = {
                           add: permissions[key]?.add || false,
                           edit: permissions[key]?.edit || false,
                           deleteRole: permissions[key]?.deleteRole || false,
                           print: permissions[key]?.print || false,
                           view: permissions[key]?.view || false,
                        };
                     }
                  }
               });

               setUserRights(mergedRights);
            }
         } else if (!isSharedMode && selectedMember) {
            const rightsByCompany = {};

            if (selectedMember.userRights?.length > 0) {
               selectedMember.userRights.forEach((right) => {
                  if (right.companyId) {
                     rightsByCompany[right.companyId] = right;
                  }
               });
            } else {
               companyList
                  ?.filter((c) => !c.isShared)
                  .forEach((company) => {
                     rightsByCompany[company.id] = { ...initialUserRights };
                  });
            }

            setUserRightsByCompany(rightsByCompany);

            let initialCompanyId = '';
            if (selectedMember.companyId) {
               initialCompanyId = String(selectedMember.companyId);
            } else if (selectedMember.userRights?.[0]?.companyId) {
               initialCompanyId = String(selectedMember.userRights[0].companyId);
            } else if (companyList?.length > 0) {
               const firstNonShared = companyList.find((c) => !c.isShared);
               initialCompanyId = String(firstNonShared?.id || '');
            }

            setSelectedCompany(initialCompanyId);

            if (initialCompanyId && rightsByCompany[initialCompanyId]) {
               const { companyId: _, ...permissions } = rightsByCompany[initialCompanyId];
               const mergedRights = { ...initialUserRights };

               Object.keys(permissions).forEach((key) => {
                  if (mergedRights.hasOwnProperty(key)) {
                     if (key === 'utility') {
                        mergedRights[key] = {
                           "Delete Unused Master": permissions[key]?.["Delete Unused Master"] || false,
                           "Synced Un-Approved Entry": permissions[key]?.["Synced Un-Approved Entry"] || false,
                           "Merge Code": permissions[key]?.["Merge Code"] || false,
                           "E-Way Bill": permissions[key]?.["E-Way Bill"] || false,
                           "Bank Import": permissions[key]?.["Bank Import"] || false,
                           "Bulk Update Suspense Account": permissions[key]?.["Bulk Update Suspense Account"] || false,
                           "Generate Dynamic Barcode": permissions[key]?.["Generate Dynamic Barcode"] || false,
                           "Check OS": permissions[key]?.["Check OS"] || false,
                           "Print Barcode": permissions[key]?.["Print Barcode"] || false,
                           "Entry Block Manager": permissions[key]?.["Entry Block Manager"] || false,
                           "Stock Approvel": permissions[key]?.["Stock Approvel"] || false,
                        };
                     } else if (key === 'chat') {
                        mergedRights[key] = {
                           view: permissions[key]?.view || false,
                           showPhone: permissions[key]?.showPhone || false,
                        };
                     } else {
                        mergedRights[key] = {
                           add: permissions[key]?.add || false,
                           edit: permissions[key]?.edit || false,
                           deleteRole: permissions[key]?.deleteRole || false,
                           print: permissions[key]?.print || false,
                           view: permissions[key]?.view || false,
                        };
                     }
                  }
               });

               setUserRights(mergedRights);
            }
         }
      }
   }, [isOpen, processedData, selectedSharedCompId, selectedMember, companyList, isSharedMode]);

   useEffect(() => {
      if (!isOpen) {
         setSelectedCompany('');
         setUserRights(initialUserRights);
         setUserRightsByCompany({});
         setExpandedSections({
            masters: false,
            sale: false,
            purchase: false,
            inventory: false,
            cash: false,
            bank: false,
         });
      }
   }, [isOpen]);

   const handleCompanyChange = (companyId) => {
      if (selectedCompany && !isSharedMode) {
         setUserRightsByCompany((prev) => ({
            ...prev,
            [selectedCompany]: {
               companyId: Number(selectedCompany),
               ...userRights,
            },
         }));
      }

      setSelectedCompany(companyId);

      if (userRightsByCompany[companyId]) {
         const { companyId: _, ...permissions } = userRightsByCompany[companyId];
         const mergedRights = { ...initialUserRights };

         Object.keys(permissions).forEach((key) => {
            if (mergedRights.hasOwnProperty(key)) {
               if (key === 'utility') {
                  mergedRights[key] = {
                     "Delete Unused Master": permissions[key]?.["Delete Unused Master"] || false,
                     "Synced Un-Approved Entry": permissions[key]?.["Synced Un-Approved Entry"] || false,
                     "Merge Code": permissions[key]?.["Merge Code"] || false,
                     "E-Way Bill": permissions[key]?.["E-Way Bill"] || false,
                     "Bank Import": permissions[key]?.["Bank Import"] || false,
                     "Bulk Update Suspense Account": permissions[key]?.["Bulk Update Suspense Account"] || false,
                     "Generate Dynamic Barcode": permissions[key]?.["Generate Dynamic Barcode"] || false,
                     "Check OS": permissions[key]?.["Check OS"] || false,
                     "Print Barcode": permissions[key]?.["Print Barcode"] || false,
                     "Entry Block Manager": permissions[key]?.["Entry Block Manager"] || false,
                     "Stock Approvel": permissions[key]?.["Stock Approvel"] || false,
                  };
               } else {
                  mergedRights[key] = {
                     add: permissions[key]?.add || false,
                     edit: permissions[key]?.edit || false,
                     deleteRole: permissions[key]?.deleteRole || false,
                     print: permissions[key]?.print || false,
                     view: permissions[key]?.view || false,
                  };
               }
            }
         });

         setUserRights(mergedRights);
      } else {
         setUserRights(initialUserRights);
      }
   };

   const toggleSection = (section) => {
      setExpandedSections((prev) => ({
         ...prev,
         [section]: !prev[section],
      }));
   };

   const getPermissionValue = (permissionKey) => {
      if (permissionKey === 'utility') {
         return userRights[permissionKey] || {
            "Delete Unused Master": false, "Synced Un-Approved Entry": false, "Merge Code": false, "E-Way Bill": false, "Bank Import": false,
            "Bulk Update Suspense Account": false, "Generate Dynamic Barcode": false, "Check OS": false, "Print Barcode": false, "Entry Block Manager": false, "Stock Approvel": false
         };
      }
      if (permissionKey === 'chat') {
         return userRights[permissionKey] || { view: false, showPhone: false };
      }
      return userRights[permissionKey] || { add: false, edit: false, deleteRole: false, print: false, view: false };
   };

   const updatePermission = (permissionKey, field, value) => {
      setUserRights((prev) => ({
         ...prev,
         [permissionKey]: {
            ...prev[permissionKey],
            [field]: value,
         },
      }));
   };

   const selectSectionPermissions = (permissionKey, value) => {
      setUserRights((prev) => {
         if (permissionKey === 'utility') {
            return {
               ...prev,
               [permissionKey]: {
                  "Delete Unused Master": value, "Synced Un-Approved Entry": value, "Merge Code": value, "E-Way Bill": value, "Bank Import": value,
                  "Bulk Update Suspense Account": value, "Generate Dynamic Barcode": value, "Check OS": value, "Print Barcode": value, "Entry Block Manager": value, "Stock Approvel": value,
               },
            };
         }
         if (permissionKey === 'chat') {
            return {
               ...prev,
               [permissionKey]: { view: value, showPhone: value },
            };
         }
         return {
            ...prev,
            [permissionKey]: {
               add: value,
               edit: value,
               deleteRole: value,
               print: value,
               view: value,
            },
         };
      });
   };

   const getSectionAllSelected = (permissionKey) => {
      const permission = getPermissionValue(permissionKey);
      if (permissionKey === 'utility') {
         return permission["Delete Unused Master"] && permission["Synced Un-Approved Entry"] && permission["Merge Code"] && permission["E-Way Bill"] && permission["Bank Import"] &&
            permission["Bulk Update Suspense Account"] && permission["Generate Dynamic Barcode"] && permission["Check OS"] && permission["Print Barcode"] && permission["Entry Block Manager"] && permission["Stock Approvel"];
      }
      if (permissionKey === 'chat') {
         return permission.view && permission.showPhone;
      }
      return permission.add && permission.edit && permission.deleteRole && permission.print && permission.view;
   };

   // NEW: Check if section has some (but not all) permissions selected
   const getSectionIndeterminate = (permissionKeys) => {
      const allSelected = permissionKeys.every((key) => getSectionAllSelected(key));
      const noneSelected = permissionKeys.every((key) => {
         const permission = getPermissionValue(key);
         return !permission.add && !permission.edit && !permission.deleteRole && !permission.print && !permission.view;
      });

      return !allSelected && !noneSelected;
   };

   const getSectionChecked = (permissionKeys) => {
      return permissionKeys.every((key) => getSectionAllSelected(key));
   };

   const selectAllPermissions = (value) => {
      const updatedRights = {};
      Object.keys(initialUserRights).forEach((key) => {
         if (key === 'utility') {
            updatedRights[key] = {
               "Delete Unused Master": value, "Synced Un-Approved Entry": value, "Merge Code": value, "E-Way Bill": value, "Bank Import": value,
               "Bulk Update Suspense Account": value, "Generate Dynamic Barcode": value, "Check OS": value, "Print Barcode": value, "Entry Block Manager": value, "Stock Approvel": value,
            };
         } else if (key === 'chat') {
            updatedRights[key] = { view: value, showPhone: value };
         } else {
            updatedRights[key] = {
               add: value,
               edit: value,
               deleteRole: value,
               print: value,
               view: value,
            };
         }
      });
      setUserRights(updatedRights);
   };

   const getGlobalAllSelected = () => {
      return Object.keys(initialUserRights).every((key) => getSectionAllSelected(key));
   };

   const getGlobalIndeterminate = () => {
      const allSelected = getGlobalAllSelected();
      const noneSelected = Object.keys(initialUserRights).every((key) => {
         const permission = getPermissionValue(key);
         if (key === 'utility') {
            return !permission["Delete Unused Master"] && !permission["Synced Un-Approved Entry"] && !permission["Merge Code"] && !permission["E-Way Bill"] && !permission["Bank Import"] &&
               !permission["Bulk Update Suspense Account"] && !permission["Generate Dynamic Barcode"] && !permission["Check OS"] && !permission["Print Barcode"] && !permission["Entry Block Manager"] && !permission["Stock Approvel"];
         }
         if (key === 'chat') {
            return !permission.view && !permission.showPhone;
         }
         return !permission.add && !permission.edit && !permission.deleteRole && !permission.print && !permission.view;
      });

      return !allSelected && !noneSelected;
   };

   // NEW: Check status for each permission type across all items
   const getPermissionTypeStatus = (permissionType) => {
      const allKeys = Object.keys(initialUserRights).filter((key) => key !== 'utility' && key !== 'chat');
      const allSelected = allKeys.every((key) => getPermissionValue(key)[permissionType]);
      const noneSelected = allKeys.every((key) => !getPermissionValue(key)[permissionType]);

      if (allSelected) return 'checked';
      if (noneSelected) return 'unchecked';
      return 'indeterminate';
   };

   const togglePermissionType = (permissionType) => {
      const status = getPermissionTypeStatus(permissionType);
      const newValue = status === 'checked' ? false : true;

      const updatedRights = {};
      Object.keys(initialUserRights).forEach((key) => {
         if (key === 'utility' || key === 'chat') {
            updatedRights[key] = { ...userRights[key] };
         } else {
            updatedRights[key] = {
               ...userRights[key],
               [permissionType]: newValue,
            };
         }
      });
      setUserRights(updatedRights);
   };

   const masterPermissions = [
      'customer',
      'vendor',
      'allAccount',
      'item',
      'category',
      'brand',
      'salerepresentative',
      'itemGroup',
      'warehouse',
      'unit',
      'screen',
      'daybook',
      'billtterm',
      'bankbranch',
      'transport',
      'driver',
      'vehicle',
      'color',
      'style',
      'size',
      'hsn',
      'countries',
      'states',
      'city',
      'area',
   ];

   // NEW: Get permission type status for a specific section
   const getSectionPermissionTypeStatus = (permissionKeys, permissionType) => {
      const allSelected = permissionKeys.every((key) => getPermissionValue(key)[permissionType]);
      const noneSelected = permissionKeys.every((key) => !getPermissionValue(key)[permissionType]);

      if (allSelected) return 'checked';
      if (noneSelected) return 'unchecked';
      return 'indeterminate';
   };

   // NEW: Toggle all permissions of a specific type for a section
   const toggleSectionPermissionType = (permissionKeys, permissionType) => {
      const status = getSectionPermissionTypeStatus(permissionKeys, permissionType);
      const newValue = status === 'checked' ? false : true;

      const updatedRights = { ...userRights };
      permissionKeys.forEach((key) => {
         updatedRights[key] = {
            ...updatedRights[key],
            [permissionType]: newValue,
         };
      });
      setUserRights(updatedRights);
   };

   const selectAllMasters = (value) => {
      const updatedRights = { ...userRights };
      masterPermissions.forEach((key) => {
         updatedRights[key] = { add: value, edit: value, deleteRole: value, print: value, view: value };
      });
      setUserRights(updatedRights);
   };

   const getAllMastersSelected = () => {
      return masterPermissions.every((key) => getSectionAllSelected(key));
   };

   const getMastersIndeterminate = () => {
      return getSectionIndeterminate(masterPermissions);
   };

   const salePermissions = ['saleinvoice', 'salereturn', 'saleorder', 'salechallan'];

   const selectAllSale = (value) => {
      salePermissions.forEach((key) => {
         setUserRights((prev) => ({
            ...prev,
            [key]: { add: value, edit: value, deleteRole: value, print: value, view: value },
         }));
      });
   };

   const getAllSaleSelected = () => {
      return salePermissions.every((key) => getSectionAllSelected(key));
   };

   const getSaleIndeterminate = () => {
      return getSectionIndeterminate(salePermissions);
   };

   const purchasePermissions = ['purchaseinvoice', 'purchasereturn', 'purchaseorder', 'purchasechallan'];

   const selectAllPurchase = (value) => {
      purchasePermissions.forEach((key) => {
         setUserRights((prev) => ({
            ...prev,
            [key]: { add: value, edit: value, deleteRole: value, print: value, view: value },
         }));
      });
   };

   const getAllPurchaseSelected = () => {
      return purchasePermissions.every((key) => getSectionAllSelected(key));
   };

   const getPurchaseIndeterminate = () => {
      return getSectionIndeterminate(purchasePermissions);
   };

   const inventoryPermissions = ['inventory', 'inventoryissue', 'inventoryreceive', 'inventorystocktransfer'];

   const selectAllInventory = (value) => {
      inventoryPermissions.forEach((key) => {
         setUserRights((prev) => ({
            ...prev,
            [key]: { add: value, edit: value, deleteRole: value, print: value, view: value },
         }));
      });
   };

   const getAllInventorySelected = () => {
      return inventoryPermissions.every((key) => getSectionAllSelected(key));
   };

   const getInventoryIndeterminate = () => {
      return getSectionIndeterminate(inventoryPermissions);
   };

   const cashPermissions = ['cashReceive', 'cashPayment'];
   const bankPermissions = ['bankReceive', 'bankPayment'];

   const handleSubmit = async () => {
      setIsLoading(true);

      try {
         if (isSharedMode && onSaveUserRights) {
            const companyPermissions = {
               companyId: Number(selectedCompany),
               ...userRights,
            };

            const payload = {
               email: selectedMember?.email || processedData?.email,
               mobile: selectedMember?.mobile || processedData?.mobile,
               userRights: [companyPermissions],
            };

            await onSaveUserRights(payload);
         } else {
            const updatedRightsByCompany = {
               ...userRightsByCompany,
               [selectedCompany]: {
                  companyId: Number(selectedCompany),
                  ...userRights,
               },
            };

            const companiesWithPermissions = Object.values(updatedRightsByCompany).filter((company) => {
               return Object.values(company).some((right) => {
                  if (typeof right !== 'object' || right === null) return false;
                  return right.add || right.edit || right.deleteRole || right.print || right.view ||
                     right.Utility1 || right.Utility2 || right.Utility3 || right.Utility4 || right.Utility5 ||
                     right.Utility6 || right.Utility7 || right.Utility8 || right.Utility9 || right.Utility10 ||
                     right.view || right.showPhone;
               });
            });

            const payload = {
               userId: selectedMember?.id || Number(userId),
               userRights: companiesWithPermissions,
            };

            console.log('Normal Mode - Payload:', payload);
            if (processedData && onSaveUserRights) {
               onSaveUserRights(payload);
            } else {
               await dispatch(updateUserRights(payload));
               await dispatch(getUser());
               onClose();
            }
         }

         onClose();
      } catch (error) {
         console.error('Error updating permissions:', error);
      } finally {
         setIsLoading(false);
      }
   };

   const PermissionRow = ({ title, permissionKey, isNested = false }) => {
      const permission = getPermissionValue(permissionKey);
      const isAllSelected = getSectionAllSelected(permissionKey);

      return (
         <Flex
            align="center"
            py={3}
            px={4}
            borderBottom="1px"
            borderColor="gray.200"
            bg={isNested ? 'gray.50' : 'white'}
            _hover={{ bg: 'gray.100' }}>
            <Flex align="center" flex="1" minW="200px">
               <Checkbox
                  isChecked={isAllSelected}
                  onChange={(e) => selectSectionPermissions(permissionKey, e.target.checked)}
                  colorScheme="blue"
                  mr={3}
               />
               <Text fontSize="sm" ml={isNested ? 4 : 0}>
                  {title}
               </Text>
            </Flex>

            <HStack spacing={8} flex="1" justify="space-around">
               <Checkbox
                  isChecked={permission.add}
                  onChange={(e) => updatePermission(permissionKey, 'add', e.target.checked)}
                  colorScheme="blue"
               />
               <Checkbox
                  isChecked={permission.edit}
                  onChange={(e) => updatePermission(permissionKey, 'edit', e.target.checked)}
                  colorScheme="blue"
               />
               <Checkbox
                  isChecked={permission.deleteRole}
                  onChange={(e) => updatePermission(permissionKey, 'deleteRole', e.target.checked)}
                  colorScheme="blue"
               />
               <Checkbox
                  isChecked={permission.print}
                  onChange={(e) => updatePermission(permissionKey, 'print', e.target.checked)}
                  colorScheme="blue"
               />
               <Checkbox
                  isChecked={permission.view}
                  onChange={(e) => updatePermission(permissionKey, 'view', e.target.checked)}
                  colorScheme="blue"
               />
            </HStack>
         </Flex>
      );
   };

   const utilityFeatures = [
      { name: "Delete Unused Master", icon: Trash2 },
      { name: "Synced Un-Approved Entry", icon: RefreshCw },
      { name: "Merge Code", icon: GitMerge },
      { name: "E-Way Bill", icon: FileText },
      { name: "Bank Import", icon: Building2 },
      { name: "Bulk Update Suspense Account", icon: Database },
      { name: "Generate Dynamic Barcode", icon: Barcode },
      { name: "Check OS", icon: Monitor },
      { name: "Print Barcode", icon: Printer },
      { name: "Entry Block Manager", icon: ShieldBan },
      { name: "Stock Approvel", icon: BoxIcon }
   ];

   const UtilityRow = () => {
      const permission = getPermissionValue('utility');

      // Colors mapped to support both light and dark mode beautifully
      const boxBg = useColorModeValue('white', 'gray.800');
      const boxBorder = useColorModeValue('gray.100', 'gray.700');
      const textColor = useColorModeValue('gray.800', 'white');
      const subTextColor = useColorModeValue('gray.600', 'gray.400');

      const cardBg = useColorModeValue('white', 'gray.700');
      const cardBgHover = useColorModeValue('gray.50', 'gray.600');
      const cardBorder = useColorModeValue('gray.200', 'gray.600');
      const cardBorderSelectedHover = useColorModeValue('blue.300', 'blue.500');

      const checkedBg = useColorModeValue('blue.50', 'blue.900');
      const checkedBorder = useColorModeValue('blue.500', 'blue.400');
      const checkedHoverBg = useColorModeValue('blue.100', 'blue.800');
      const checkedBorderHover = useColorModeValue('blue.600', 'blue.300');

      const iconBoxBg = useColorModeValue('gray.100', 'gray.600');
      const iconBoxCheckedBg = useColorModeValue('blue.100', 'blue.800');

      const textCheckedColor = useColorModeValue('blue.800', 'blue.200');

      const iconColor = useColorModeValue('#718096', '#A0AEC0'); // gray.500 to gray.400
      const iconCheckedColor = useColorModeValue('#2B6CB0', '#63B3ED'); // blue.600 to blue.300

      return (
         <Box py={6} px={6} mt={2} mb={2} borderRadius="xl" bg={boxBg} boxShadow="sm" border="1px" borderColor={boxBorder}>
            <Flex justifyContent="space-between" alignItems="center" mb={5}>
               <Text fontSize="lg" fontWeight="bold" color={textColor} display="flex" alignItems="center">
                  <Box mr={3} as="span" color="blue.500" display="inline-flex" alignItems="center" justifyContent="center">
                     <Wrench size={20} />
                  </Box>
                  Utility Features Access
               </Text>
               <Flex align="center">
                  <Text fontSize="sm" fontWeight="medium" color={subTextColor} mr={3}>
                     Select All
                  </Text>
                  <Box
                     onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        selectSectionPermissions('utility', !getSectionAllSelected('utility'));
                     }}
                     cursor="pointer"
                  >
                     <Switch
                        isChecked={getSectionAllSelected('utility')}
                        colorScheme="blue"
                        size="md"
                        pointerEvents="none"
                     />
                  </Box>
               </Flex>
            </Flex>

            <SimpleGrid columns={{ base: 2, sm: 3, md: 4, lg: 5 }} spacing={4}>
               {utilityFeatures.map((feature, index) => {
                  const isChecked = !!permission[feature.name];
                  const FeatureIcon = feature.icon;
                  return (
                     <Box
                        key={index}
                        onClick={(e) => {
                           e.preventDefault();
                           e.stopPropagation();
                           updatePermission('utility', feature.name, !isChecked);
                        }}
                        borderWidth="2px"
                        borderColor={isChecked ? checkedBorder : cardBorder}
                        borderRadius="lg"
                        p={4}
                        bg={isChecked ? checkedBg : cardBg}
                        transition="all 0.2s"
                        _hover={{
                           borderColor: isChecked ? checkedBorderHover : cardBorderSelectedHover,
                           bg: isChecked ? checkedHoverBg : cardBgHover,
                           transform: 'translateY(-2px)',
                           boxShadow: 'md'
                        }}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        position="relative"
                        w="full"
                        cursor="pointer"
                     >
                        {isChecked && (
                           <CheckCircleIcon
                              position="absolute"
                              top={2}
                              right={2}
                              color="blue.500"
                              boxSize={4}
                           />
                        )}
                        <Box
                           p={3}
                           borderRadius="full"
                           bg={isChecked ? iconBoxCheckedBg : iconBoxBg}
                           mb={3}
                           display="flex"
                           alignItems="center"
                           justifyContent="center"
                        >
                           <FeatureIcon size={20} color={isChecked ? iconCheckedColor : iconColor} />
                        </Box>
                        <Text
                           fontSize="xs"
                           fontWeight={isChecked ? 'bold' : 'medium'}
                           color={isChecked ? textCheckedColor : subTextColor}
                           textAlign="center"
                           lineHeight="short"
                        >
                           {feature.name}
                        </Text>
                     </Box>
                  );
               })}
            </SimpleGrid>
         </Box>
      );
   };

   const chatFeatures = [
      { name: "view", label: "Show Chat", icon: MessageSquare },
      { name: "showPhone", label: "Show Mobile Number", icon: Phone }
   ];

   const ChatRow = () => {
      const permission = getPermissionValue('chat');

      // Colors mapped to support both light and dark mode beautifully
      const boxBg = useColorModeValue('white', 'gray.800');
      const boxBorder = useColorModeValue('gray.100', 'gray.700');
      const textColor = useColorModeValue('gray.800', 'white');
      const subTextColor = useColorModeValue('gray.600', 'gray.400');

      const cardBg = useColorModeValue('white', 'gray.700');
      const cardBgHover = useColorModeValue('gray.50', 'gray.600');
      const cardBorder = useColorModeValue('gray.200', 'gray.600');
      const cardBorderSelectedHover = useColorModeValue('green.300', 'green.500');

      const checkedBg = useColorModeValue('green.50', 'green.900');
      const checkedBorder = useColorModeValue('green.500', 'green.400');
      const checkedHoverBg = useColorModeValue('green.100', 'green.800');
      const checkedBorderHover = useColorModeValue('green.600', 'green.300');

      const iconBoxBg = useColorModeValue('gray.100', 'gray.600');
      const iconBoxCheckedBg = useColorModeValue('green.100', 'green.800');
      const textCheckedColor = useColorModeValue('green.800', 'green.200');
      const iconColor = useColorModeValue('#718096', '#A0AEC0');
      const iconCheckedColor = useColorModeValue('#38A169', '#68D391');

      return (
         <Box py={6} px={6} mt={2} mb={2} borderRadius="xl" bg={boxBg} boxShadow="sm" border="1px" borderColor={boxBorder}>
            <Flex justifyContent="space-between" alignItems="center" mb={5}>
               <Text fontSize="lg" fontWeight="bold" color={textColor} display="flex" alignItems="center">
                  <Box mr={3} as="span" color="green.500" display="inline-flex" alignItems="center" justifyContent="center">
                     <MessageSquare size={20} />
                  </Box>
                  Chat Access
               </Text>
               <Flex align="center">
                  <Text fontSize="sm" fontWeight="medium" color={subTextColor} mr={3}>
                     Select All
                  </Text>
                  <Box
                     onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        selectSectionPermissions('chat', !getSectionAllSelected('chat'));
                     }}
                     cursor="pointer"
                  >
                     <Switch
                        isChecked={getSectionAllSelected('chat')}
                        colorScheme="green"
                        size="md"
                        pointerEvents="none"
                     />
                  </Box>
               </Flex>
            </Flex>

            <SimpleGrid columns={{ base: 2, sm: 3, md: 4, lg: 5 }} spacing={4}>
               {chatFeatures.map((feature, index) => {
                  const isChecked = !!permission[feature.name];
                  const FeatureIcon = feature.icon;
                  return (
                     <Box
                        key={index}
                        onClick={(e) => {
                           e.preventDefault();
                           e.stopPropagation();
                           updatePermission('chat', feature.name, !isChecked);
                        }}
                        borderWidth="2px"
                        borderColor={isChecked ? checkedBorder : cardBorder}
                        borderRadius="lg"
                        p={4}
                        bg={isChecked ? checkedBg : cardBg}
                        transition="all 0.2s"
                        _hover={{
                           borderColor: isChecked ? checkedBorderHover : cardBorderSelectedHover,
                           bg: isChecked ? checkedHoverBg : cardBgHover,
                           transform: 'translateY(-2px)',
                           boxShadow: 'md'
                        }}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        position="relative"
                        w="full"
                        cursor="pointer"
                     >
                        {isChecked && (
                           <CheckCircleIcon
                              position="absolute"
                              top={2}
                              right={2}
                              color="green.500"
                              boxSize={4}
                           />
                        )}
                        <Box p={3} borderRadius="full" bg={isChecked ? iconBoxCheckedBg : iconBoxBg} mb={3} display="flex" alignItems="center" justifyContent="center">
                           <FeatureIcon size={20} color={isChecked ? iconCheckedColor : iconColor} />
                        </Box>
                        <Text fontSize="xs" fontWeight={isChecked ? 'bold' : 'medium'} color={isChecked ? textCheckedColor : subTextColor} textAlign="center" lineHeight="short">
                           {feature.label}
                        </Text>
                     </Box>
                  );
               })}
            </SimpleGrid>
         </Box>
      );
   };

   const CollapsibleSection = ({
      title,
      sectionKey,
      permissionKeys,
      onSelectAll,
      isAllSelected,
      isIndeterminate,
      children,
   }) => {
      const isExpanded = expandedSections[sectionKey];

      return (
         <Box borderBottom="1px" borderColor="gray.200">
            <Flex align="center" py={3} px={4} bg="white" _hover={{ bg: 'gray.50' }}>
               <Box cursor="pointer" onClick={() => toggleSection(sectionKey)} mr={2}>
                  {isExpanded ? <ChevronDownIcon boxSize={5} /> : <ChevronRightIcon boxSize={5} />}
               </Box>
               <Flex align="center" flex="1" minW="200px">
                  <Checkbox
                     isChecked={isAllSelected}
                     isIndeterminate={isIndeterminate}
                     onChange={(e) => onSelectAll(e.target.checked)}
                     colorScheme="blue"
                     mr={3}
                  />
                  <Text fontSize="sm" fontWeight="medium">
                     {title}
                  </Text>
               </Flex>
               <HStack spacing={8} flex="1" justify="space-around">
                  <Checkbox
                     isChecked={getSectionPermissionTypeStatus(permissionKeys, 'add') === 'checked'}
                     isIndeterminate={getSectionPermissionTypeStatus(permissionKeys, 'add') === 'indeterminate'}
                     onChange={() => toggleSectionPermissionType(permissionKeys, 'add')}
                     colorScheme="blue"
                  />
                  <Checkbox
                     isChecked={getSectionPermissionTypeStatus(permissionKeys, 'edit') === 'checked'}
                     isIndeterminate={getSectionPermissionTypeStatus(permissionKeys, 'edit') === 'indeterminate'}
                     onChange={() => toggleSectionPermissionType(permissionKeys, 'edit')}
                     colorScheme="blue"
                  />
                  <Checkbox
                     isChecked={getSectionPermissionTypeStatus(permissionKeys, 'deleteRole') === 'checked'}
                     isIndeterminate={getSectionPermissionTypeStatus(permissionKeys, 'deleteRole') === 'indeterminate'}
                     onChange={() => toggleSectionPermissionType(permissionKeys, 'deleteRole')}
                     colorScheme="blue"
                  />
                  <Checkbox
                     isChecked={getSectionPermissionTypeStatus(permissionKeys, 'print') === 'checked'}
                     isIndeterminate={getSectionPermissionTypeStatus(permissionKeys, 'print') === 'indeterminate'}
                     onChange={() => toggleSectionPermissionType(permissionKeys, 'print')}
                     colorScheme="blue"
                  />
                  <Checkbox
                     isChecked={getSectionPermissionTypeStatus(permissionKeys, 'view') === 'checked'}
                     isIndeterminate={getSectionPermissionTypeStatus(permissionKeys, 'view') === 'indeterminate'}
                     onChange={() => toggleSectionPermissionType(permissionKeys, 'view')}
                     colorScheme="blue"
                  />
               </HStack>
            </Flex>
            <Collapse in={isExpanded}>
               <Box bg="gray.50">{children}</Box>
            </Collapse>
         </Box>
      );
   };

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
         <ModalOverlay />
         <ModalContent maxH="90vh" m={4}>
            <ModalHeader borderBottom="1px" borderColor="gray.200">
               <Text fontSize="xl" fontWeight="semibold">
                  {isSharedMode ? 'Set Permissions for Shared Company' : 'Manage User Permissions'}
               </Text>
            </ModalHeader>
            <ModalCloseButton />

            <ModalBody p={0}>
               <Box p={6} borderBottom="1px" borderColor="gray.200" bg="gray.50">
                  <FormControl>
                     <Flex align="center">
                        <FormLabel mb={0} mr={4} minW="80px" fontWeight="semibold">
                           Company
                        </FormLabel>
                        <Select
                           placeholder="Select Company"
                           value={selectedCompany}
                           onChange={(e) => handleCompanyChange(e.target.value)}
                           maxW="300px"
                           bg="white">
                           {companyList
                              ?.filter((company) => !company.isShared)
                              .map((company) => (
                                 <option key={company.id} value={company.id.toString()}>
                                    {company.name}
                                 </option>
                              ))}
                        </Select>
                     </Flex>
                  </FormControl>
               </Box>

               <Box>
                  <Flex
                     align="center"
                     py={3}
                     px={4}
                     bg="gray.100"
                     borderBottom="1px"
                     borderColor="gray.300"
                     fontWeight="semibold"
                     fontSize="sm"
                     color="gray.700">
                     <Flex align="center" flex="1" minW="200px">
                        <Checkbox
                           isChecked={getGlobalAllSelected()}
                           isIndeterminate={getGlobalIndeterminate()}
                           onChange={(e) => selectAllPermissions(e.target.checked)}
                           colorScheme="blue"
                           mr={3}
                        />
                        <Text>SELECT ALL</Text>
                     </Flex>
                     <HStack spacing={8} flex="1" justify="space-around">
                        <Checkbox
                           isChecked={getPermissionTypeStatus('add') === 'checked'}
                           isIndeterminate={getPermissionTypeStatus('add') === 'indeterminate'}
                           onChange={() => togglePermissionType('add')}
                           colorScheme="blue">
                           <Text>ADD</Text>
                        </Checkbox>
                        <Checkbox
                           isChecked={getPermissionTypeStatus('edit') === 'checked'}
                           isIndeterminate={getPermissionTypeStatus('edit') === 'indeterminate'}
                           onChange={() => togglePermissionType('edit')}
                           colorScheme="blue">
                           <Text>EDIT</Text>
                        </Checkbox>
                        <Checkbox
                           isChecked={getPermissionTypeStatus('deleteRole') === 'checked'}
                           isIndeterminate={getPermissionTypeStatus('deleteRole') === 'indeterminate'}
                           onChange={() => togglePermissionType('deleteRole')}
                           colorScheme="blue">
                           <Text>DELETE</Text>
                        </Checkbox>
                        <Checkbox
                           isChecked={getPermissionTypeStatus('print') === 'checked'}
                           isIndeterminate={getPermissionTypeStatus('print') === 'indeterminate'}
                           onChange={() => togglePermissionType('print')}
                           colorScheme="blue">
                           <Text>PRINT</Text>
                        </Checkbox>
                        <Checkbox
                           isChecked={getPermissionTypeStatus('view') === 'checked'}
                           isIndeterminate={getPermissionTypeStatus('view') === 'indeterminate'}
                           onChange={() => togglePermissionType('view')}
                           colorScheme="blue">
                           <Text>VIEW</Text>
                        </Checkbox>
                     </HStack>
                  </Flex>

                  <VStack spacing={0} align="stretch">
                     <PermissionRow title="Dashboard" permissionKey="dashboard" />

                     <CollapsibleSection
                        title="Masters"
                        sectionKey="masters"
                        permissionKeys={masterPermissions}
                        isAllSelected={getAllMastersSelected()}
                        isIndeterminate={getMastersIndeterminate()}
                        onSelectAll={selectAllMasters}>
                        <PermissionRow title="Customer" permissionKey="customer" isNested />
                        <PermissionRow title="Vendor" permissionKey="vendor" isNested />
                        <PermissionRow title="All Account" permissionKey="allAccount" isNested />
                        <PermissionRow title="Item" permissionKey="item" isNested />
                        <PermissionRow title="Category" permissionKey="category" isNested />
                        <PermissionRow title="Brand" permissionKey="brand" isNested />
                        <PermissionRow title="Sale Representative" permissionKey="salerepresentative" isNested />
                        <PermissionRow title="Item Group" permissionKey="itemGroup" isNested />
                        <PermissionRow title="Warehouse" permissionKey="warehouse" isNested />
                        <PermissionRow title="Unit" permissionKey="unit" isNested />
                        <PermissionRow title="Screen" permissionKey="screen" isNested />
                        <PermissionRow title="Daybook" permissionKey="daybook" isNested />
                        <PermissionRow title="Bill Term" permissionKey="billtterm" isNested />
                        <PermissionRow title="Bank Branch" permissionKey="bankbranch" isNested />
                        <PermissionRow title="Transport" permissionKey="transport" isNested />
                        <PermissionRow title="Driver" permissionKey="driver" isNested />
                        <PermissionRow title="Vehicle" permissionKey="vehicle" isNested />
                        <PermissionRow title="Color" permissionKey="color" isNested />
                        <PermissionRow title="Style" permissionKey="style" isNested />
                        <PermissionRow title="Size" permissionKey="size" isNested />
                        <PermissionRow title="HSN" permissionKey="hsn" isNested />
                        <PermissionRow title="Countries" permissionKey="countries" isNested />
                        <PermissionRow title="States" permissionKey="states" isNested />
                        <PermissionRow title="City" permissionKey="city" isNested />
                        <PermissionRow title="Area" permissionKey="area" isNested />
                     </CollapsibleSection>

                     <CollapsibleSection
                        title="Sale"
                        sectionKey="sale"
                        permissionKeys={salePermissions}
                        isAllSelected={getAllSaleSelected()}
                        isIndeterminate={getSaleIndeterminate()}
                        onSelectAll={selectAllSale}>
                        <PermissionRow title="Sale Invoice" permissionKey="saleinvoice" isNested />
                        <PermissionRow title="Sale Return" permissionKey="salereturn" isNested />
                        <PermissionRow title="Sale Order" permissionKey="saleorder" isNested />
                        <PermissionRow title="Sale Challan" permissionKey="salechallan" isNested />
                     </CollapsibleSection>

                     <CollapsibleSection
                        title="Purchase"
                        sectionKey="purchase"
                        permissionKeys={purchasePermissions}
                        isAllSelected={getAllPurchaseSelected()}
                        isIndeterminate={getPurchaseIndeterminate()}
                        onSelectAll={selectAllPurchase}>
                        <PermissionRow title="Purchase Invoice" permissionKey="purchaseinvoice" isNested />
                        <PermissionRow title="Purchase Return" permissionKey="purchasereturn" isNested />
                        <PermissionRow title="Purchase Order" permissionKey="purchaseorder" isNested />
                        <PermissionRow title="Purchase Challan" permissionKey="purchasechallan" isNested />
                     </CollapsibleSection>

                     <CollapsibleSection
                        title="Inventory"
                        sectionKey="inventory"
                        permissionKeys={inventoryPermissions}
                        isAllSelected={getAllInventorySelected()}
                        isIndeterminate={getInventoryIndeterminate()}
                        onSelectAll={selectAllInventory}>
                        <PermissionRow title="Inventory" permissionKey="inventory" isNested />
                        <PermissionRow title="Inventory Issue" permissionKey="inventoryissue" isNested />
                        <PermissionRow title="Inventory Receive" permissionKey="inventoryreceive" isNested />
                        <PermissionRow
                           title="Inventory Stock Transfer"
                           permissionKey="inventorystocktransfer"
                           isNested
                        />
                     </CollapsibleSection>

                     <CollapsibleSection
                        title="Cash"
                        sectionKey="cash"
                        permissionKeys={cashPermissions}
                        isAllSelected={getSectionChecked(cashPermissions)}
                        isIndeterminate={getSectionIndeterminate(cashPermissions)}
                        onSelectAll={(value) => {
                           if (selectedCompany) {
                              selectSectionPermissions('cashReceive', value);
                              selectSectionPermissions('cashPayment', value);
                           }
                        }}>
                        <PermissionRow title="Cash Receive" permissionKey="cashReceive" isNested />
                        <PermissionRow title="Cash Payment" permissionKey="cashPayment" isNested />
                     </CollapsibleSection>

                     <CollapsibleSection
                        title="Bank"
                        sectionKey="bank"
                        permissionKeys={bankPermissions}
                        isAllSelected={getSectionChecked(bankPermissions)}
                        isIndeterminate={getSectionIndeterminate(bankPermissions)}
                        onSelectAll={(value) => {
                           if (selectedCompany) {
                              selectSectionPermissions('bankReceive', value);
                              selectSectionPermissions('bankPayment', value);
                           }
                        }}>
                        <PermissionRow title="Bank Receive" permissionKey="bankReceive" isNested />
                        <PermissionRow title="Bank Payment" permissionKey="bankPayment" isNested />
                     </CollapsibleSection>

                     <PermissionRow title="Journal Vouchers" permissionKey="journalvouchers" />
                     <PermissionRow title="Reports" permissionKey="reports" />
                     <PermissionRow title="Profile" permissionKey="profile" />
                     <PermissionRow title="Company Profile" permissionKey="companyprofile" />
                     <UtilityRow />
                     <ChatRow />
                  </VStack>
               </Box>
            </ModalBody>

            <ModalFooter borderTop="1px" borderColor="gray.200">
               <Button variant="outline" mr={3} onClick={onClose}>
                  Cancel
               </Button>
               <Button
                  colorScheme="green"
                  onClick={handleSubmit}
                  isLoading={isLoading}
                  loadingText="Saving..."
                  isDisabled={!selectedCompany}>
                  Save
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default ManageUserRoleForm;
